export default "__VITE_ASSET__BbHmkUZw__"